/** @jsxImportSource @emotion/react */
import { BasePage } from 'components';
import { useMerchantApplicationContext } from 'contexts';
import { PageAction } from 'enums';
import { ActivationStepKey } from 'modules/activation/ActivationConfig';
import ActivationFlow from 'modules/activation/ActivationFlow';
import { useEffect, useState } from 'react';
import { logEvent } from 'utils';

type BusinessDetailsPageProps = {
  onComplete: () => void | Promise<void>;
  initialStepKey?: ActivationStepKey;
};

export default function BusinessDetailsPage({
  onComplete,
  initialStepKey = ActivationStepKey.LocationDetails,
}: BusinessDetailsPageProps): React.JSX.Element {
  const [activeStepKey, setActiveStepKey] =
    useState<ActivationStepKey>(initialStepKey);

  const { merchantApplicationId } = useMerchantApplicationContext();

  useEffect(() => {
    logEvent(PageAction.merchantOnboardingPVBusinessDetails, {
      merchantApplicationId,
    });
  }, []);

  return (
    <BasePage title={null} variant="layout" fullWidth>
      <ActivationFlow
        activeStepKey={activeStepKey}
        onStepChange={setActiveStepKey}
        onComplete={onComplete}
      />
    </BasePage>
  );
}
